import React, { Component } from 'react';
import './EnterDualFactorCodePopup.css';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Popup from '../../components/popup/Popup';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import Input from '../../inputs/input/Input';
import mainAPI from '../../api/MainAPI';
import toasts from '../../utils/toasts';
import { onLoginSuccess } from '../../pages/login/Login';

export default class EnterDualFactorCodePopup extends Component {
	constructor(props) {
		super(props);
		this.myRefs = {};
	}

	submit = async () => {
		const code = this.myRefs.code.getValue();
		const user = await mainAPI.user.loginWithCode({
			dual_factor_guid: this.props.dualFactorGuid,
			dual_factor_code: code
		});
		if (!user || !user.token) return toasts.show('Incorrect Code');
		onLoginSuccess(user);
	};

	render() {
		return (
			<Popup {...this.props} show={this.props.show} className="g-enter-dual-factor-code-popup">
				<Card>
					<div>
						<Label larger black center>
							Enter the OTP code sent to you
						</Label>
						<Label black center>
							Expires after 1 minute
						</Label>
						<Input placeholder={'code'} ref={(ref) => (this.myRefs.code = ref)} />
						<PrimaryButton onClick={this.submit}>Submit</PrimaryButton>
					</div>
				</Card>
			</Popup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/popups/enterDualFactorCodePopup/EnterDualFactorCodePopup.jsx